import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import {
  DataType,
  IDENTITY_VERIFICATION_METHOD,
  IFilter,
  IIdentity,
  IIdentityVerificationMethods,
  MODIFICATION_TYPE,
} from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { SessionService } from "src/app/providers/session.service";
import { IdentityStatusChangeHistoricDataSource } from "./identity-status-change-historic-datasource";

@Component({
  selector: "app-identity-status-change-historic",
  templateUrl: "./identity-status-change-historic.component.html",
  styleUrls: ["./identity-status-change-historic.component.scss"],
})
export class IdentityStatusChangeHistoricComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public dataSource: IdentityStatusChangeHistoricDataSource;
  /** Raw active filters, kept in sync to feed `app-item-filter` via the `filterFor` pipe. */
  public activeFilters: IFilter[] = [];
  public dataTypeDate = DataType.DATE;
  public dataTypeChoice = DataType.CHOICE;
  public displayedColumns: string[] = [
    "identityChangeStatus",
    "verification",
    "verificationMethod",
    "modificationType",
    "periodStart",
    "periodEnd",
  ];
  public MODIFICATION_TYPE = MODIFICATION_TYPE;
  public IDENTITY_VERIFICATION_METHOD = IDENTITY_VERIFICATION_METHOD;
  public serviceIdentityVerifMethod: IIdentityVerificationMethods[];
  private onDestroy$ = new Subject<void>();

  constructor(
    public sessionService: SessionService,
    public translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { identity: IIdentity[]; serviceIdentityVerifMethod: IIdentityVerificationMethods[] }
  ) {
    this.serviceIdentityVerifMethod = this.data.serviceIdentityVerifMethod;
  }

  ngOnInit(): void {
    this.dataSource = new IdentityStatusChangeHistoricDataSource();
    this.dataSource.loadData(this.data.identity);
  }

  ngAfterViewInit(): void {
    this.initPaginatorAndSort();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  public initPaginatorAndSort(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public applyFilter(filter: IFilter): void {
    this.dataSource.setFilter(filter);
    this.activeFilters = [...(this.dataSource?.getAllFilters() ?? [])];
  }

  public getFilter(propertyName: string): IFilter {
    return this.dataSource.getFilter(propertyName);
  }
}
